import React from 'react';
import { Typography, FormControlLabel, Switch } from '@mui/material';

const SwitchComponent = ({ title, enabled, label, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={enabled}
          onChange={() => onChange(title)}
          sx={{
            width: 50,
            height: 28,
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            '& .MuiSwitch-switchBase': {
              padding: 1,
              top: '50%',
              transform: 'translateY(-50%)',
              '&.Mui-checked': {
                transform: 'translateX(15px) translateY(-50%)',
                color: '#fff',
                boxShadow: 'none'
              },
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#1890ff'
              }
            },
            '& .MuiSwitch-thumb': {
              width: 24,
              height: 24,
              boxShadow: 'none',
              marginLeft: enabled ? '0' : '-6px',

            },
            '& .MuiSwitch-track': {
              borderRadius: 13,
              opacity: 1,
              position: 'relative',
              background: enabled
                ? 'linear-gradient(10deg, #007A33, #39ff14)'
                : 'linear-gradient(40deg, #F42B4F, #FE610D)', // Red-orange gradient for "OFF""OFF"
              '&::before': {
                content: enabled ? '"ON"' : '""',
                color: '#000',
                fontWeight: 'bold',
                fontSize: 10,
                position: 'absolute',
                top: '50%',
                left: '5px', // Align "ON" text on the left side
                transform: 'translateY(-50%)',
              },
              '&::after': {
                content: !enabled ? '"OFF"' : '""',
                color: '#000',
                fontWeight: 'bold',
                fontSize: 10,
                position: 'absolute',
                top: '50%',
                right: '5px', // Align "OFF" text on the right side
                transform: 'translateY(-50%)',
              },
            },
          }}
        />

      }
      label={
        <Typography variant="h6" sx={{ textAlign: 'left', flexGrow: 1 }}>

          {label ? (
            label.charAt(0).toUpperCase() + label.slice(1).replace(/_/g, ' ')
          ) : (
            "No Label" // Default text or fallback if selectedLabel is undefined or null
          )}

        </Typography>
      }
      sx={{
        margin: '10px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '90%',
        flexDirection: 'row-reverse',
      }}
    />
  );
}

export default SwitchComponent;